const domain = process.env.REACT_APP_DOMAIN;

export default domain;
